import DebtorService from '../services/DebtorService';
import { Payments } from '../types/Payment/Payment';

const customerHasPaymentMethod = async (customerId: string, paymentMethod: Payments.PaymentMethod) => {
  let customer = await DebtorService.getDebtor(customerId);
  if (!customer) return false;
  return customer.paymentMethod === paymentMethod;
};

const customerHasValidAddress = async (customerId: string) => {
  let customer = await DebtorService.getDebtor(customerId);
  if (!customer) return false;

  let address = customer.address;
  if (!address) return false;

  return Boolean((address.line || (address.street && address.houseNumber)) && address.zipCode && address.city && address.country);
};

export { customerHasPaymentMethod, customerHasValidAddress };
